<template>
    <div>
        <validation-observer ref="observer" v-slot="{ handleSubmit }" >
            <b-form @submit.prevent="handleSubmit(onSubmit)">
                <b-row >
                    <b-col cols="auto">
                        
                        <!-- Code Artwork -->
                        <validation-provider
                            name="codeArtwork"
                            :rules="{ required: isValid }"
                            v-slot="validationContext"
                        >
                            <b-form-group 
                                label-cols          ="4" 
                                label-cols-lg       ="4" 
                                label-size          ="sm"
                            >
                                <template v-slot:label>
                                    Code Artwork
                                </template>
                            
                                <b-form-select id="inputCodeArtwork" v-model="form.codeArtwork"  :options="codeOpt" :state="getValidationState(validationContext)"  trim></b-form-select>
                                <b-form-invalid-feedback id="inputCodeArtwork">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>

                        <!-- Type Artwork -->
                        <validation-provider
                            name="TypeArtwork"
                            :rules="{ required: isValid }"
                            v-slot="validationContext"
                        >
                            <b-form-group 
                                label-cols          ="4" 
                                label-cols-lg       ="4" 
                                label-size          ="sm"
                            >
                                <template v-slot:label>
                                    Type Artwork
                                </template>
                            
                                <b-form-input id="inputTypeArtwork" v-model="form.typeArtwork"  :state="getValidationState(validationContext)"  trim></b-form-input>
                                <b-form-invalid-feedback id="inputTypeArtwork">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>

                        <!-- Supplier -->
                        <validation-provider
                            name="supplier"
                            :rules="{ required: isValid }"
                            v-slot="validationContext"
                        >
                            <b-form-group 
                                label-cols          ="4" 
                                label-cols-lg       ="4" 
                                label-size          ="sm"
                            >
                                <template v-slot:label>
                                    Supplier
                                </template>
                                <b-form-input id="inputSupplierA" v-model="form.supplier"  :state="getValidationState(validationContext)"  trim></b-form-input>
                                <b-form-invalid-feedback id="inputSupplierA">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>

                        <!-- Detail Artwork -->
                        <validation-provider
                            name="DetailArtwork"
                            :rules="{ required: isValid }"
                            v-slot="validationContext"
                        >
                            <b-form-group 
                                label-cols          ="4" 
                                label-cols-lg       ="4" 
                                label-size          ="sm"
                            >
                                <template v-slot:label>
                                    Detail Artwork
                                </template>
                            
                                <b-form-input id="DetailCodeArtwork" v-model="form.detailArtwork"  :state="getValidationState(validationContext)"  trim></b-form-input>
                                <b-form-invalid-feedback id="DetailCodeArtwork">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>

                        
                        
                    </b-col>
                    <b-col cols="auto">
                        

                        <!-- Images Artwork -->
                        <validation-provider
                            name="imagesArtwork"
                            :rules="{ required: isValid }"
                            v-slot="validationContext"
                        >
                            <b-form-group 
                                label-cols          ="4" 
                                label-cols-lg       ="4" 
                                label-size          ="sm"
                            >
                                <template v-slot:label>
                                    Images Artwork
                                </template>
                                <b-form-file
                                    multiple
                                    ref="fileInput"
                                    id="inputImagesArtwork"
                                    v-model="form.imagesArtwork"
                                    :state="getValidationState(validationContext)"
                                    placeholder="Choose  file here..."
                                    accept=".jpg, .png,"
                                    no-drop
                                    :file-name-formatter="formatNames"
                                    v-on:change="onFileChange"
                                ></b-form-file>
                                    <div v-for="img in imagesUrl" :key="img.name">
                                        <p class="small">
                                            <a :href="img.src" target="_blank">{{img.fileName}}</a>
                                            <b-badge href="#" v-on:click="removeImg(img.fileName,imagesUrl)" variant="light">
                                                <b-icon icon="x-circle-fill" font-scale="1" variant="danger"></b-icon>
                                            </b-badge>
                                        </p>
                                    </div>
                                <b-form-invalid-feedback id="inputImagesArtwork">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>
                        <div>
                            <b-button block  variant="success" size="sm" type="submit">Save</b-button>
                        </div>
                    </b-col>
                    
                    
                    
                </b-row>
                    
            </b-form>
        </validation-observer>

        <div>
            <b-table
                striped 
                responsive
                hover
                :items="dataArtwork"
                :fields="fields"
            >
                <template #cell(index)="data">
                    {{ data.index + 1 }}
                </template>
                <template #cell(images)="{item}"   >
                    <p class="small" v-for="img in item.images" :key="img.src">
                        <a :href="img.src" target="_blank">{{img.fileName.substring(0,26)}}</a>
                    </p>
                </template>
                <template #cell(actions)="data">
                    <b-button title="Hapus" size="xs" variant="danger" v-on:click="deleteData(data.index)">
                        <b-icon icon="trash-fill" aria-label="Help"></b-icon>
                    </b-button>
                    <b-button title="Ubah" size="xs" variant="warning" v-on:click="editData(data.index)">
                        <b-icon icon="pencil-square" aria-label="Help"></b-icon>
                    </b-button>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
export default {
    name:'FormArtwork',
    data(){
        return{
            formName: 'Artwork',
            modulName: null,
            tabIndex:3,
            isValid:false,
            fields:[
                {key:'index', label:'#'},
                'code','type','supplier','detail',
                {key:'images', label:'Images'},
                {key:'actions', label:''},
            ],
            dataArtwork: [
                
            ],
            imagesUrl:[],
            form:{
                indexId:null,
                codeArtwork:null,
                typeArtwork:null,
                supplier:null,
                imagesArtwork:[],
                detailArtwork:null,
            },
            codeOpt:[
                {value:'1', text:'Code A'},
                {value:'2', text:'Code B'},
                {value:'3', text:'Code C'},
                {value:'4', text:'Code D'},
            ]
        }
    },
    methods:{
        ...mapActions('productDesign',['add','delete','update','get']),
        getValidationState({ dirty, validated, valid = null }) {
            return dirty || validated ? valid : null;
        },
        onSubmit(){
            if(this.form.indexId == null){
                this.add({
                    formname: this.formName,
                    code:this.form.codeArtwork,
                    type:this.form.typeArtwork,
                    supplier:this.form.supplier,
                    detail:this.form.detailArtwork,
                    images:this.imagesUrl,
                })
            }else{
                this.update({
                    formname: this.formName,
                    id:this.form.indexId,
                    code:this.form.codeArtwork,
                    type:this.form.typeArtwork,
                    supplier:this.form.supplier,
                    detail:this.form.detailArtwork,
                    images:this.imagesUrl,
                })
            }
            
            this.clearForm()
        
        },
        clearForm(){
            this.form.indexId = null
            this.form.codeArtwork = null
            this.form.typeArtwork = null
            this.form.supplier = null
            this.form.imagesArtwork = []
            this.imagesUrl = []
            this.form.detailArtwork = null
            this.$refs.observer.reset()
        },
        onFileChange(e){
            var file = e.target.files
            for (var i=0; i < file.length; i++){
                // this.form.imagesAcc.push(file[i])
                // this.imagesUrl = URL.createObjectURL(file[i])
                let img = {
                    src: URL.createObjectURL(file[i]),
                    fileName: file[i].name,
                }
                this.imagesUrl.push(img)
            }
        },
        goToList(){
            this.$router.push({name:'AppsProductDesignPage'})
        },
        removeImg:function(filename,modelname){
            modelname.splice(filename,1);
            return this.formatNames()
        },
        formatNames() {
        return this.imagesUrl.length === 0 ? this.$refs.fileInput.reset() : `${this.imagesUrl.length} files selected`
        },
        deleteData(id){
            this.delete({id:id,formname:this.formName})
        },
        editData(index){
            this.get({id:index,formname:this.formName})
            this.form.indexId       = index
            this.form.codeArtwork   = this.artworkDetail.code
            this.form.typeArtwork   = this.artworkDetail.type
            this.form.supplier      = this.artworkDetail.supplier
            this.form.detailArtwork = this.artworkDetail.detail
            this.imagesUrl          = this.artworkDetail.images
        },
        getArtworkList(){
            this.dataArtwork = this.artworkList
        }
    },
    mounted(){
        if(this.key_id != null){
            this.modulName = 'Edit'
        }else{
            this.modulName = 'Create'
        }
        this.getArtworkList()
    },
    computed:{
    ...mapGetters('productDesign',['artworkList','artworkDetail']),
        
    }
}
</script>